import * as Yup from "yup"

export const ContactSchema = Yup.object({
    Name : Yup.string().min(5).max(25).required("Please Enter Name"),
    EmailS : Yup.string().email().required("Please Enter Email"),
    Mobile : Yup.string().min(8).max(15).required("Please Enter Number"),
    Message : Yup.string().min(5).max(250).required("Please Enter Message"),    
})